import * as React from "react";
import { Box, Container, Typography } from "@mui/material";
import { useLanguage } from "../Language";

interface FourOhFourPageProps {
  message?: string;
}

export class NotFoundError extends Error {
  constructor(message = "Not Found") {
    super(message);
    this.name = "NotFoundError";
  }
}

export const FourOhFourPage: React.FC<FourOhFourPageProps> = function ({ message }) {
  const { translate } = useLanguage();
  return (
    <Container>
        <Box sx={{ textAlign: "center", mt: 4 }}>
            <Typography variant="h1" fontWeight={700}>404</Typography>
            <Typography variant="h4" gutterBottom>{translate("PageNotFound")}</Typography>
            {message && <Typography variant="h4" gutterBottom>{message}</Typography>}
        </Box>
      </Container>
  );
};
